import React from "react";

import { Pagination } from "@material-ui/lab";

export default function PageSelector({ currentPage, users, setCurrentPage }) {
  return (
    <div>
      <Pagination
        count={users.length < 10 ? currentPage : currentPage + 1}
        shape="rounded"
        page={currentPage}
        size="large"
        variant="outlined"
        hideNextButton={users.length < 10}
        hidePrevButton={currentPage === 1}
        onChange={(event, page) => {
          setCurrentPage(page);
        }}
      />
    </div>
  );
}
